import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {ChevronLeft, Clock3, Crown, MapPin, Sparkles} from "lucide-react";
import {SiteHeader} from "@/components/SiteHeader";
import {api, authHeaders, CATEGORY_LABEL} from "@/lib/inner";

const Section = ({icon: Icon, title, sub, children}) => (
  <section className="settings-section"><div className="settings-title"><Icon/><div><h2>{title}</h2><p>{sub}</p></div></div>{children}</section>
);

export default function SettingsPage() {
  const [cfg, setCfg] = useState(null), [pct, setPct] = useState(""), [msg, setMsg] = useState("");
  useEffect(() => { api.get("/settings", authHeaders()).then(r => { setCfg(r.data); setPct(r.data.member_discount_percent); }); }, []);
  const save = async () => {
    if (pct === "" || Number(pct) < 0 || Number(pct) > 100) { setMsg("Masukkan angka 0–100"); return; }
    try { const r = await api.put("/settings/membership", {member_discount_percent: Number(pct)}, authHeaders()); setMsg(`Tersimpan: diskon member ${r.data.member_discount_percent}%`); }
    catch (e) { setMsg(e.response?.data?.detail?.[0]?.msg ? "Masukkan angka 0–100" : e.response?.data?.detail || "Gagal menyimpan"); }
  };
  if (!cfg) return <><SiteHeader staff/><main className="settings-page"><p className="muted">Memuat pengaturan…</p></main></>;
  return <>
    <SiteHeader staff/>
    <main className="settings-page">
      <Link className="back-link" to="/dashboard"><ChevronLeft/> Kembali ke jadwal</Link>
      <p className="eyebrow"><Sparkles size={15}/> KONFIGURASI OPERASIONAL</p>
      <div className="settings-heading"><div><h1>Pengaturan <em>outlet.</em></h1><p className="muted">Menu dan harga dikelola lewat CMS (/cms).</p></div></div>
      <div className="settings-grid">
        <Section icon={MapPin} title="Outlet" sub={cfg.can_edit ? "Empat outlet INNER di Depok." : "Outlet tempat Anda bertugas."}>
          {cfg.branches.map(b => <div className="setting-row" key={b.id} data-testid={`settings-outlet-${b.id}`}><strong>{b.name}</strong><span>{b.address}</span></div>)}
        </Section>
        <Section icon={Sparkles} title="Menu perawatan" sub="Jumlah perawatan per kategori.">
          {cfg.categories.map(c => <div className="setting-row" key={c.name}><strong>{CATEGORY_LABEL[c.name]}</strong><span>{c.count} perawatan</span></div>)}
        </Section>
        <Section icon={Crown} title="Membership" sub="Diskon persen dari harga normal untuk pelanggan yang mencentang 'Saya member'.">
          <div className="setting-row member-setting">
            <strong>Diskon member</strong>
            {cfg.can_edit ? <span className="pct-edit"><input data-testid="member-discount-input" type="number" min="0" max="100" value={pct} onChange={e => setPct(e.target.value)}/>%<button data-testid="member-discount-save" onClick={save}>Simpan</button></span> : <span data-testid="member-discount-value">{cfg.member_discount_percent}%</span>}
          </div>
          {msg && <p className="settings-msg" data-testid="member-discount-message">{msg}</p>}
        </Section>
        <Section icon={Clock3} title="Jam operasional" sub="Digunakan saat menghitung slot tersedia.">
          <div className="setting-row"><strong>Semua outlet</strong><span>Buka {cfg.hours.opening} WIB setiap hari · penerimaan pelanggan terakhir {cfg.hours.last_start} WIB · satu booking per jam kedatangan</span></div>
        </Section>
      </div>
      <p className="settings-note">{cfg.can_edit ? "Admin Pusat dapat mengatur seluruh outlet." : "Perubahan pengaturan dilakukan oleh Admin Pusat."}</p>
    </main>
  </>;
}
